module.exports = __webpack_public_path__ + "img/1.5233616c.png";